import "../../design/header.css";
import profilePhoto from "../../assets/header/profileImage.gif";
import { FaGithub, FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import TypewriterTerminal from "../other/tools/TypewriterTerminal";

export default function Header() {
    const startYear = 2021;
    const currentYear = new Date().getFullYear();
    const experience = currentYear - startYear;

    return (
        <section className="headerSection" id="home">
            <div className="headerContainer">

                {/* LEFT: Cyber Content */}
                <div className="headerContent">
                    <div className="terminalBadge glass-panel">
                        <span className="statusDot"></span>
                        <TypewriterTerminal />
                    </div>

                    <h1 className="headerMainTitle">
                        FULL-STACK <br />
                        <span className="gradientText">ENGINEER</span>
                    </h1>

                    <div className="headerInfo">
                        <span className="infoBadge glass-panel">⚡ Middle Level</span>
                        <span className="infoBadge glass-panel">🚀 {experience}+ Yrs Exp</span>
                        <span className="infoBadge glass-panel">🎯 Architecture & APIs</span>
                    </div>

                    <p className="headerDescription">
                        Architecting high-performance web solutions, specialized in scalable Node.js microservices,
                        React ecosystems, and robust database architecture.
                    </p>

                    <div className="headerSkills">
                        <span>REACT</span>
                        <span>NODE.JS</span>
                        <span>POSTGRESQL</span>
                        <span>C++</span>
                        <span>SYSTEM DESIGN</span>
                    </div>

                    <div className="headerActions">
                        <div className="headerSocials">
                            <a href="https://github.com/Rektovski" target="_blank" rel="noreferrer" className="socialIcon glass-panel">
                                <FaGithub />
                            </a>
                            <a href="https://www.linkedin.com/in/otarmurmanishvili/" target="_blank" rel="noreferrer" className="socialIcon glass-panel">
                                <FaLinkedinIn />
                            </a>
                            <a href="https://www.facebook.com/OtexRektovski" target="_blank" rel="noreferrer" className="socialIcon glass-panel">
                                <FaFacebookF />
                            </a>
                        </div>
                    </div>
                </div>

                {/* RIGHT: Visual Frame */}
                <div className="headerImageWrapper">
                    <div className="cyberFrame">
                        <div className="frameCorner top-left"></div>
                        <div className="frameCorner top-right"></div>
                        <div className="frameCorner bottom-left"></div>
                        <div className="frameCorner bottom-right"></div>
                        <div className="imageGlow"></div>
                        <img src={profilePhoto} alt="Developer profile" className="headerImage" />
                    </div>
                </div>

            </div>
        </section>
    );
}